import { render, staticRenderFns } from "./clxx-edit.vue?vue&type=template&id=21ee5df0&"
import script from "./clxx-edit.vue?vue&type=script&lang=js&"
export * from "./clxx-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports